module.exports = __webpack_public_path__ + "img/CrossDoc-logo.e62ab4c2.svg";